import React, { useState, useEffect } from 'react';
import {
    Box,
    Card,
    CardContent,
    TextField,
    Button,
    Typography,
    Alert,
    MenuItem,
    CircularProgress,
} from '@mui/material';
import { MeetingRoom, ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import API from '../api/axios';

function AddRoom() {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        roomNumber: '',
        floor: '',
        roomType: '',
    });
    const [roomTypes, setRoomTypes] = useState([]);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        API.get('/rooms/types')
            .then((res) => setRoomTypes(res.data))
            .catch(() => setRoomTypes(['Apartament', 'Tripla', 'Double Twin', 'Double Matrimoniala', '4 Stele']));
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setLoading(true);

        try {
            await API.post('/rooms', {
                ...form,
                floor: parseInt(form.floor),
            });
            setSuccess(`Camera ${form.roomNumber} a fost adăugată cu succes!`);
            setForm({ roomNumber: '', floor: '', roomType: '' });
        } catch (err) {
            setError(err.response?.data?.message || 'Eroare la adăugarea camerei');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ maxWidth: 500, mx: 'auto', mt: 4 }}>
            <Button
                startIcon={<ArrowBack />}
                onClick={() => navigate('/')}
                sx={{ mb: 2, color: 'text.secondary' }}
            >
                Înapoi la Dashboard
            </Button>

            <Card sx={{ borderRadius: 3, boxShadow: '0 8px 30px rgba(0,0,0,0.08)' }}>
                <Box
                    sx={{
                        background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)',
                        p: 3,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                    }}
                >
                    <MeetingRoom sx={{ fontSize: 36, color: '#fff' }} />
                    <Typography variant="h5" sx={{ color: '#fff', fontWeight: 700 }}>
                        Adaugă cameră nouă
                    </Typography>
                </Box>

                <CardContent sx={{ p: 3 }}>
                    {error && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>{error}</Alert>}
                    {success && <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>{success}</Alert>}

                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="Număr cameră"
                            name="roomNumber"
                            value={form.roomNumber}
                            onChange={handleChange}
                            required
                            sx={{ mb: 2.5 }}
                            placeholder="Ex: 101, 202, 305"
                        />

                        <TextField
                            fullWidth
                            label="Etaj"
                            name="floor"
                            type="number"
                            value={form.floor}
                            onChange={handleChange}
                            required
                            sx={{ mb: 2.5 }}
                            placeholder="Ex: 1, 2, 3"
                        />

                        <TextField
                            fullWidth
                            select
                            label="Tip cameră"
                            name="roomType"
                            value={form.roomType}
                            onChange={handleChange}
                            required
                            sx={{ mb: 3 }}
                        >
                            {roomTypes.length === 0 ? (
                                <MenuItem disabled>
                                    <CircularProgress size={20} sx={{ mr: 1 }} /> Se încarcă...
                                </MenuItem>
                            ) : (
                                roomTypes.map((type) => (
                                    <MenuItem key={type} value={type}>
                                        {type}
                                    </MenuItem>
                                ))
                            )}
                        </TextField>

                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            disabled={loading}
                            sx={{
                                py: 1.5,
                                borderRadius: 2,
                                fontSize: '1rem',
                                fontWeight: 600,
                                background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #0d47a1 0%, #1a237e 100%)',
                                },
                            }}
                        >
                            {loading ? 'Se adaugă...' : 'Adaugă camera'}
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </Box>
    );
}

export default AddRoom;
